import { useState } from 'react';

const Input = ({ value, onChange, placeholder, isErrored }: { value: string; onChange: (value: string) => void; placeholder: string; isErrored?: boolean }) => {
    const [focused, setFocused] = useState(false);

    return (
        <div className="relative w-full">
            <input
                type="text"
                value={value}
                onChange={e => onChange(e.target.value)}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                placeholder={placeholder}
                className={`
          w-full px-4 py-3 rounded-xl border
          text-gray-800 bg-white
          transition-all duration-200 outline-none
          ${isErrored ? 'border-red-500 shadow-[0_0_0_3px_rgba(239,68,68,0.15)]' : focused ? 'border-purple-500 shadow-[0_0_0_3px_rgba(255,140,0,0.15)]' : 'border-gray-300'}
        `}
            />
        </div>
    );
};

export default Input;
